import { UntypedFormGroup } from "@angular/forms";
import { WellComponent } from "../models";

export function hangerAbovePreviousShoe(control: UntypedFormGroup) {
    const wellConfiguration = control?.parent?.parent?.getRawValue() as WellComponent[]; //Using RawValue so we can get the disabled inputs.
    const hangerMd :number = control?.value;
    if(!wellConfiguration || !hangerMd || control.pristine){
        return null;
    }
    const tubularString = control?.parent.getRawValue() as WellComponent;
    const idx = wellConfiguration.findIndex(wc => wc.id == tubularString.id);
    if(idx == 0){
        return null;
    }
    let previousTubular = wellConfiguration[idx - 1];
    if (previousTubular.type == 'Tieback') {
        previousTubular = wellConfiguration[idx - 2];
    }
    const previousCasingShoe = previousTubular.shoeMd;
    if( hangerMd > previousCasingShoe){
       return { error: `Hanger must be set above previous shoe: ${previousCasingShoe}ft \n` };
    }
    return null;
 }
